import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/icon_structure.svg'


const _hoisted_1 = { class: "ctp00100-top-bg" }
const _hoisted_2 = { class: "row justify-center ctp00100-top-container" }
const _hoisted_3 = { class: "ctp00100-category q-gutter-y-xs" }
const _hoisted_4 = { class: "row items-end" }
const _hoisted_5 = { class: "col text-right ctp00100-date" }
const _hoisted_6 = { class: "q-mr-xs" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-right text-weight-bolder ctp00100-count"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "text-primary"
}
const _hoisted_11 = {
  key: 3,
  class: "text-right text-weight-bolder ctp00100-count ctp00100-all"
}
const _hoisted_12 = { class: "column ctp00100-right-area" }
const _hoisted_13 = {
  class: "row",
  style: {"height":"150px"}
}
const _hoisted_14 = { class: "col flex justify-center" }
const _hoisted_15 = { class: "column items-center" }
const _hoisted_16 = {
  class: "row justify-center",
  style: {"height":"calc(100% - 150px)"}
}

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import NewsAreaScroll from '../components/scroll/NewsAreaScroll.vue';
import commaFormat from '../common/utils/numberUtils';
import http from '../common/axios-common';
import ResultStatusCode from '../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../common/code/HttpResponseStatusCode';
import loginUserStore from '../store/loginUserStore';

interface Category {
  sup_category_id: number;
  item_count: number;
  sup_category: string;
}

// 掲載品目数

export default /*@__PURE__*/_defineComponent({
  __name: 'CTP00100',
  setup(__props) {

const router = useRouter();

// カテゴリーinterface
const category = ref<[Category]>();

// システム日付
const today = ref<string>('');

// 掲載品目数取得
const getCategories = () => {
  http
    .post('/ctp001001/category')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        category.value = response.data.categoryList;
        today.value = response.data.sysDate;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// ログイン情報取得
const getLoginUser = () => {
  const loginUser = loginUserStore();
  const { po_type } = storeToRefs(loginUser);
  http
    .post('/ctp001001/loginUser')
    .then((response) => {
      // 異常終了の場合
      if (response.data.common.status === ResultStatusCode.ERROR) {
        router.push({ name: 'error' });
      } else {
        // ログインユーザー情報をstoreに設定
        loginUser.setLoginUser(response.data.loginUser);
        if (po_type.value === 'PO_RE_ARIBA') {
          router.push({ name: 'orderInquiry' });
        }
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// 初期表示処理
getLoginUser();
getCategories();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col" }, [
            _createElementVNode("label", { class: "text-primary text-weight-bold ctp00100-title" }, "掲載品目数")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(today.value), 1),
            _cache[0] || (_cache[0] = _createElementVNode("label", null, "時点", -1))
          ])
        ]),
        _createVNode(_component_q_card, {
          flat: "",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "q-gutter-y-sm" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.item_count,
                    class: _normalizeClass([
                'row items-end justify-between',
                item.sup_category === 'ALL' && 'ctp00100-sparate',
                'ctp00100-item-name',
              ])
                  }, [
                    (item.sup_category !== 'ALL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.sup_category), 1))
                      : _createCommentVNode("", true),
                    (item.sup_category !== 'ALL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (item.item_count !== 0)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                class: "ctp00100-item-font",
                                to: {
                    name: 'search',
                    params: { type: '1', supCategory: item.sup_category_id },
                  }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(commaFormat)(item.item_count)), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true),
                          (item.item_count === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.item_count), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (item.sup_category === 'ALL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.sup_category), 1))
                      : _createCommentVNode("", true),
                    (item.sup_category === 'ALL')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(commaFormat)(item.item_count)), 1))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_q_btn, {
              to: { name: 'search', params: { type: '0' } },
              color: "primary",
              class: "ctp00100-top-button"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", null, " キー検索 ", -1)),
                  _createVNode(_component_q_icon, {
                    size: "60px",
                    name: "mdi-magnify"
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              to: { name: 'search', params: { type: '1' } },
              color: "primary",
              class: "ctp00100-top-button structure-search"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "column items-center" }, [
                  _createElementVNode("label", null, " 構造検索 "),
                  _createElementVNode("div", { style: {"width":"60px"} }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    })
                  ])
                ], -1)
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(NewsAreaScroll, { "display-screen": "1" })
        ])
      ])
    ])
  ]))
}
}

})